import {personal_root} from '../config';
import vue from 'vue';

function url(api) {
  return personal_root + '/topic/' + api;
}

/**
 * 获取表格数据
 * @return {*}
 */
export function api_getTable(num,find) {
    return vue.http({
        method: 'get',
        url: url('getTable'),
        params:{
            data:find,
            num:num
        }
    });
}

export function api_getClass() {
  return vue.http({
    method: 'get',
    url: url('getClass'),
  });
}


/**
 * 获取选题信息
 * @return {*}
 */
export function api_getTopic(id) {
  return vue.http({
    method: 'get',
    url: url('getTopic'),
    params:{
      id : id
    }
  });
}


/**
 * 添加新闻信息
 * @param data
 * @return {*}
 */
export function api_save(data) {
  let form = new FormData();
  for (let key in data) {
    if (data.hasOwnProperty(key)) {
      form.append(key, data[key]);
    }
  }
  return vue.http({
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: 'post',
    url: url('save'),
    body: form
  });
}

export function api_updateItem(data) {
  return vue.http({
    method: 'post',
    url: url('updateItem'),
    body: data
  });
}


/**
 * 删除数据
 * @return {*}
 */
export function api_deleteItems(ids) {
  return vue.http({
    method: 'post',
    url: url('deleteItems'),
    body: {id:ids}
  });
}

export function api_getItemSignStatus(id) {
  return vue.http({
    method: 'get',
    url: url('getItemSignStatus'),
    params: { id }
  });
}

export function api_updateItemSignStatus(id, status, reason = null) {
  return vue.http({
    method: 'post',
    url: url('updateItemSignStatus'),
    params: { id, status, reason }
  });
}

export function api_deleteItemSignStatus(ids) {
  return vue.http({
    method: 'post',
    url: url('deleteItemSignStatus'),
    params: { ids }
  });
}



/**
 * 获取审核表格数据
 * @return {*}
 */
export function api_serviceTable() {
    return vue.http({
        method: 'get',
        url: url('getservice'),
    });
}




/**
 * 通过表格数据
 * @return {*}
 */
export function api_passTotal(data) {
    return vue.http({
        method: 'post',
        url: url('passTotal'),
        body:{
            id:data
        }
    });
}

/**
 * 不通过表格数据
 * @return {*}
 */
export function api_noTotal(data) {
    return vue.http({
        method: 'post',
        url: url('noTotal'),
        body:{
            id:data
        }
    });
}